var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.button)?_c('button',{class:[
        'z-tag__button',
        ("z-tag--" + _vm.computedTheme),
        {'z-tag--marker': _vm.isMarker},
        {'is-active': _vm.isActive}],on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2):_c('span',{class:['z-tag', ("z-tag--" + _vm.computedTheme)]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }